module.exports = __webpack_public_path__ + "static/media/a3.f6dc73f2.jpg";